// style
import { IconBrandInstagram, IconBrandTelegram, IconBrandWhatsapp, IconX } from '@tabler/icons-react';
// style
import './style/style.css'
// controller
import useSendData from '../../hook/sendData';
import { PostContactUs } from '../../services/client/contactUs/postContactUs';
// form
import { useForm } from 'react-hook-form';
// error
import { onError } from '../../features/error/error';
// toast
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import { Link } from 'react-router';

const ContactUs = () => {
    const { register, handleSubmit }: any = useForm<any>();
    let sendData;
    const { send, pending } = useSendData(sendData, PostContactUs, 'فرم با موفقیت ارسال شد', null, null)
    const onSubmit = (data: any) => {
        send(data);
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <section className="contactus bg-white py-5">
                <div className="container">
                    <div className="row gy-4 overflow-hidden">
                        <div className="col-md-6 order-md-0 order-1" data-aos="fade-left">
                            <h1 className='fw-bold card-title h4'>تماس با ما</h1>
                            <p className='mt-3 line-30 card-text mb-2'>
                                آنچه آریا استیل راد را متمایز می‌کند، توجه به جزئیات، استفاده از بهترین متریال، کنترل دقیق کیفیت و ارائه راهکارهای متناسب با نیاز هر مشتری است. هدف ما تنها فروش یک محصول نیست؛ بلکه ایجاد تجربه‌ای مطمئن و ماندگار برای مشتریان و همراهی آن‌ها در تجهیز آشپزخانه‌ای حرفه‌ای و کارآمد است.
                            </p>
                            <div className='row mt-4'>
                                <div className='col-4 font-contact'>
                                    <Link to={'https://instagram.com/ariya.steel.rad'} className='text-site text-decoration-none'>
                                        <div data-aos="fade-up" className='card card-body border-0 shadow'>
                                            <p className='text-site text-center fw-bold mb-2'>
                                                ariya.steel.rad
                                            </p>
                                            <div className='d-flex justify-content-center'>
                                                <IconBrandInstagram size={25} />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className='col-4 font-contact'>
                                    <Link to={'https://t.me/ariyasteelrad'} className='text-site text-decoration-none'>
                                        <div data-aos="fade-up" className='card card-body border-0 shadow'>
                                            <p className='text-site text-center fw-bold mb-2'>ariyasteelrad@</p>
                                            <div className='d-flex justify-content-center'>
                                                <IconBrandTelegram size={25} className=' mx-3' />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className='col-4 font-contact'>
                                    <Link to={'https://wa.me/+989906332606'} className='text-site text-decoration-none'>
                                        <div data-aos="fade-up" className='card card-body border-0 shadow'>
                                            <p className='text-site text-center fw-bold mb-2'>
                                                989906332606+
                                            </p>
                                            <div className='d-flex justify-content-center'>
                                                <IconBrandWhatsapp size={25} />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            <button data-bs-toggle="modal" data-bs-target="#contact-modal" className="hero-btn btn-dark mt-4">
                                فرم تماس با ما
                            </button>
                        </div>
                        <div className="col-md-6 order-md-1 order-0" data-aos="fade-right">
                            <img src={require('./../../assets/media/banner/contact.jpg')} alt="" className="contact-img w-100" />
                        </div>
                    </div>
                </div>
            </section>
            <div className='modal fade' id='contact-modal'>
                <div className='modal-dialog modal-dialog-centered'>
                    <div className='modal-content'>
                        <div className='modal-header justify-content-between'>
                            <h6 className="mb-0 fw-bold">
                                فرم تماس با ما
                            </h6>
                            <IconX data-bs-dismiss="modal" />
                        </div>
                        <div className='modal-body'>
                            <form className="mt-4" onSubmit={handleSubmit(onSubmit, onError)}>
                                <div className="row gy-4">
                                    <div className="col-md-6">
                                        <fieldset className="form-floating">
                                            <input id="username" type="text" placeholder="نام و نام خانوادگی" className="form-control"
                                                {...register('name', { required: 'فیلد نام الزامی است' })}
                                            />
                                            <label htmlFor="username" className="form-label">
                                                نام و نام خانوادگی
                                            </label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-6">
                                        <fieldset className="form-floating">
                                            <input id="email" type="email" placeholder="ایمیل" className="form-control"
                                                {...register('email', { required: 'فیلد ایمیل الزامی است' })}
                                            />
                                            <label htmlFor="email" className="form-label">
                                                ایمیل
                                            </label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-12">
                                        <fieldset className="form-floating">
                                            <input id="title" type="text" placeholder="موضوع" className="form-control"
                                                {...register('subject', { required: 'فیلد موضوع الزامی است' })}
                                            />
                                            <label htmlFor="title" className="form-label">
                                                موضوع
                                            </label>
                                        </fieldset>
                                    </div>
                                    <div className="col-md-12">
                                        <fieldset className="form-floating">
                                            <textarea className="form-control" name="title" id="title" placeholder="توضیحات"
                                                {...register('text', { required: 'فیلد توضیحات الزامی است' })}
                                            ></textarea>
                                            <label htmlFor="title" className="form-label">
                                                توضیحات
                                            </label>
                                        </fieldset>
                                    </div>
                                    <div className="col-12">
                                        <button disabled={pending} className="btn btn-primary">
                                            {pending ? 'درحال ارسال...' : 'ارسال'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default ContactUs;